import {defineStore} from "pinia";
import {useDeviceStore} from "../devices/DeviceStore";
import {useUISettingsStore} from "../uisettings/UISettingsStore";
import {t} from "i18next";
export const useRemoteControlStore = defineStore("remoteControl", {
	state: () => ({
		isRCModalOpen: false as boolean,
		isSlaOtpStepperModalOpen: false as boolean,
		targetDeviceID: 0 as number,
		targetSPPIdx: undefined as number | undefined,
		targetSPPSubIdx: undefined as number | undefined,
		isRemotelyControllable: false as boolean,
		reasonForNoRemoteControl: "" as string,
	}),
	getters: {},
	actions: {
		openRCModal(targetDeviceID: number, targetSPPIdx?: number, targetSPPSubIdx?: number) {
			const onlineStatus = useDeviceStore().getOnlineStatusByDeviceId(targetDeviceID);
			const device = useDeviceStore().getDeviceById(String(targetDeviceID));
			const isDeviceRemotelyControllable = device?.isRemotelyControllable ?? false;
			const reasonForNoRemoteControl = device?.reasonForNoRemoteControl ?? "";
			if (!onlineStatus) {
				useUISettingsStore().setError({
					type: "error",
					message: t("remote_control.device-offline"),
				});
				return;
			}
			this.isRCModalOpen = true;
			this.targetDeviceID = targetDeviceID;
			this.isRemotelyControllable = isDeviceRemotelyControllable;
			this.reasonForNoRemoteControl = reasonForNoRemoteControl;
			this.targetSPPIdx = targetSPPIdx;
			this.targetSPPSubIdx = targetSPPSubIdx;
		},
		closeRCModal() {
			this.isRCModalOpen = false;
			this.targetDeviceID = 0;
			this.targetSPPIdx = undefined;
			this.targetSPPSubIdx = undefined;
		},
	},
});